export default {
  title: 'Page two',
  'Hi from the second page': 'Hi from the second page',
  'Welcome to page 2': 'Welcome to page 2',
  'Go back to the homepage': 'Go back to the homepage',
};
